import { Button } from '@euler/components/Button';
import { useModalWrapperSize } from '@euler/components/ModalWrapper';
import { FormGroup, FormInput } from '@euler/components/form';
import { FontFamily } from '@euler/components/typography';
import { useResponsiveContext } from '@euler/functions/responsive/ResponsiveContext';
import { useBackButtonHandler } from '@euler/functions/useBackButtonHandler';
import { wrapNavigatorScreen } from '@euler/functions/wrapNavigatorScreen';
import { usePersistFn } from '@euler/utils/hooks';
import { useState } from 'react';
import { ScrollView } from 'react-native';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { useTheme } from 'styled-components';
import { BackButton } from '../components/BackButton';
import { CustomPageHeader } from '../components/CustomPageHeader';

export const NewPasswordScreen = wrapNavigatorScreen(
  ({ onDone }: { onDone: (password: string) => void }) => {
    const theme = useTheme();
    const { rpx } = useResponsiveContext();
    useModalWrapperSize({ width: rpx(375), height: rpx(500) });
    const onGoBack = useBackButtonHandler();
    const insets = useSafeAreaInsets();
    const [password, setPassword] = useState('');

    const onConfirm = usePersistFn(() => {
      if (password.trim().length === 0) return;
      onDone(password.trim());
    });

    return (
      <>
        <ScrollView
          contentContainerStyle={{
            paddingTop: insets.top + rpx(80),
            paddingLeft: rpx(20),
            paddingRight: rpx(20),
            paddingBottom: rpx(20),
          }}
        >
          <CustomPageHeader title="继续" subTitle="输入新密码以进行重置" />

          <FormGroup
            css={`
              margin-top: ${rpx(32)}px;
            `}
          >
            <FormInput
              placeholder="请输入新密码"
              value={password}
              onChange={setPassword}
              isPassword
              keyboardType="ascii-capable"
              returnKeyType="done"
              autoFocus
              onSubmitEditing={onConfirm}
              css={`
                font-size: ${rpx(16)}px;
                font-family: ${FontFamily.NotoSans.Medium};
                letter-spacing: 0.5px;
              `}
            />
          </FormGroup>

          <Button
            title="重置密码"
            disabled={password.trim().length === 0}
            onPress={onConfirm}
            textStyle={{ color: '#fff', fontSize: rpx(16) }}
            css={`
              background-color: ${theme.colors.primary};
            `}
          />
        </ScrollView>
        <BackButton
          onPress={onGoBack}
          color={'#333'}
          css={`
            position: absolute;
            left: ${rpx(20)}px;
            top: ${insets.top + rpx(15)}px;
          `}
        />
      </>
    );
  },
  { headerShown: false },
);
